import React from 'react';

import ReactMarkdown from "react-markdown";

const Content = ({ content = <></> }) => {
    return (
        <ReactMarkdown
            linkTarget="_blank"
            children={content}
            components={{
              a(props) {
                const {node, ...rest} = props
                let href = rest.href;
                if(href.indexOf(window.location.hostname) < 0){
                  if(href.indexOf('?') < 0){
                    href = href + '?openInBrowser=true';
                  } else {
                    href = href + '&openInBrowser=true';
                  }
                  
                }
                return <a href={href} target={rest.target}>{rest.children}</a>
              }
            }}
        ></ReactMarkdown>
    )
}

export default Content;